import firstLeftSlide from 'assets/images/result-first-left-slide.png'
import firstRightSlide from 'assets/images/result-first-right-slide.png'
import secondLeftSlide from 'assets/images/result-second-left-slide.png'
import secondRightSlide from 'assets/images/result-second-right-slide.png'
import thirdLeftSlide from 'assets/images/result-third-left-slide.png'
import thirdRightSlide from 'assets/images/result-third-right-slide.png'
import fourthLeftSlide from 'assets/images/result-fourth-left-slide.png'
import fourthRightSlide from 'assets/images/result-fourth-right-slide.png'

export const LEFT_SIDE_SLIDES = [
  { id: '1', image: firstLeftSlide },
  { id: '2', image: secondLeftSlide },
  { id: '3', image: thirdLeftSlide },
  { id: '4', image: fourthLeftSlide },
]

export const RIGHT_SIDE_SLIDES = [
  { id: '1', image: firstRightSlide },
  { id: '2', image: secondRightSlide },
  { id: '3', image: thirdRightSlide },
  { id: '4', image: fourthRightSlide },
]
